export enum SKELETON_CONST {
  TEST_ID = 'skeleton',
}

export enum Direction {
  LEFT_TO_RIGHT = 'ltr',
  RIGHT_TO_LEFT = 'rtl',
}

export enum Radius {
  SHARP = 'sharp',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  PILL = 'pill',
}
